/**
 * Determines the length of the synopsis to be displayed for a [[Film]].
 */
export var FilmSynopsisLength;
(function (FilmSynopsisLength) {
    /**
     * The shortest available synopsis will be displayed.
     */
    FilmSynopsisLength["Shortest"] = "Shortest";
    /**
     * The longest available synopsis will be displayed.
     */
    FilmSynopsisLength["Longest"] = "Longest";
    /**
     * Only the short synopsis will be display, if available.
     */
    FilmSynopsisLength["ShortOnly"] = "ShortOnly";
    /**
     * Only the full synopsis will be display, if available.
     */
    FilmSynopsisLength["FullOnly"] = "FullOnly";
})(FilmSynopsisLength || (FilmSynopsisLength = {}));
